import React from "react";
import CommonNavBar from "views/components/CommonNavBar";
import styles from "./DeviceManage.module.less";
import { useNavigate } from "react-router-dom";
import { showDeviceModal } from "./components/device-modal";
import { getUserLoginDevice, deleteDeviceToken } from "@/api/mine";
import { useEffect, useState, useRef } from "react";
import { Toast } from "react-vant";
import DSBridge from "dsbridge";

const DeviceManage = () => {
  const navigate = useNavigate();
  const [deviceList, setDeviceList] = useState([]);
  const LoadingRef = useRef(null);
  const handleDeleteDevice = async (deviceId, isSelf) => {
    const res = await deleteDeviceToken({ device_id: deviceId });
    if (res.code === 200) {
      init();
      // if (isSelf) {
      //   DSBridge.call("auth.logout");
      //   localStorage.clear();
      //   window.location.replace("#/login/logon");
      // } else {
      // init();
      // }
    }
  };
  const init = async () => {
    LoadingRef.current = Toast.loading({
      message: "正在获取已登录设备...",
      forbidClick: true,
      duration: 0,
      forbidClick: false,
    });
    const res = await getUserLoginDevice();
    if (res.code === 200) {
      setDeviceList(res.data);
    }
    if (LoadingRef.current?.clear) {
      LoadingRef.current.clear();
    }
  };
  useEffect(() => {
    init();
    return () => {
      if (LoadingRef.current?.clear) {
        LoadingRef.current.clear();
      }
    };
  }, []);
  return (
    <div className={styles["device-manage-container"]}>
      <CommonNavBar
        onClickBack={() => {
          navigate(-1);
        }}
        title="设备管理"
      />
      <img
        className={styles["right-banner"]}
        src={require("@/images/mine/img_integration_top_bg.png")}
      />
      {deviceList.length > 0 ? (
        <>
          <div className={styles["device-text"]}>{`已登录设备（${
            deviceList.length || 0
          }）`}</div>
          <img
            className={styles["border-img"]}
            src={require("@/images/mine/device-manage/border.png")}
          />
          <div className={styles["device-list"]}>
            {deviceList.map((item) => {
              return (
                <div
                  className={styles["list-item"]}
                  key={`${item.device_id}-${item.login_time}`}
                >
                  <div className={styles["list-item-left"]}>
                    <div className={styles["left-title"]}>
                      <span>{item.device_name}</span>
                      {item.is_self && (
                        <img
                          className={styles["left-title-icon"]}
                          src={require("@/images/mine/device-manage/my.png")}
                        />
                      )}
                    </div>
                    <div className={styles["left-time"]}>{item.login_time}</div>
                  </div>
                  {!item.is_self && (
                    <div
                      onClick={() => {
                        showDeviceModal({
                          message:
                            "是否下线设备？下线后该设备将退出登录当前账号",
                          onConfirm: () => {
                            handleDeleteDevice(item.device_id, item.is_self);
                          },
                          isShowCancel: true,
                          isShowConfirm: true,
                          cancelText: "取消",
                          confirmText: "下线设备",
                        });
                      }}
                      className={styles["list-item-right"]}
                    >
                      <img
                        src={require("@/images/mine/device-manage/delete.png")}
                      />
                    </div>
                  )}
                </div>
              );
            })}
            <div className={styles["device-desc"]}>
              <div>为保证账号安全，账号仅限本人设备使用。</div>
              <div>
                每个账号最多可以登录2台设备，包括1台手机及1台平板。第2台手机或第2台平板将无法登录账号。
              </div>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
};

export default DeviceManage;
